export const LABELS = {
  TITLE: 'Enjoying Sorted?',
  SUBTITLE:
    'We hope your experience has been delightful and if it has, please consider giving us a review.',
  BUTTON: 'Okay',
};
